export const FIRST_NAME = "non";
export const LAST_NAME = "transmis";


// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/member/coverage/enums/invalidMemberNameSynchroTypes.js